import { Component, Inject } from '@angular/core';
import { OrderFoods } from '../../../../../@domain/order-foods';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-order-cart-dialog',
    templateUrl: './order-cart-dialog.component.html',
    styleUrl: './order-cart-dialog.component.scss',
    standalone: false
})
export class OrderCartDialogComponent {
  orderId !: string
  orderDetails = {} as OrderFoods


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      orderId: string,
      orderDetails: OrderFoods
    },
    private dialogRef: MatDialogRef<OrderCartDialogComponent>) {
    this.orderId = this.data.orderId;
    this.orderDetails = this.data.orderDetails;
  }

  onOrderCreated() {
    this.dialogRef.close('Order created');
  }

}
